module.exports = __webpack_public_path__ + "img/C2.abfc7534.png";